// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_section__wxobX {
  min-height: 100vh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4rem 1.5rem;
  background: #80808008;
  border-top: 1px solid #8080801a;
  max-height: 100vh;
  position: relative; }

.styles_essentialsSection__ZImve {
  width: 100%;
  max-height: 100vh; }

.styles_contentWrapper__bQIHD {
  width: -webkit-fill-available;
  margin: 0 auto;
  max-width: 80vw; }

.styles_headerSection__dbeGN {
  text-align: center; }

.styles_sectionTitle__pneHu {
  font-size: 1.875rem;
  font-weight: 300;
  color: #808080e6;
  margin-bottom: 1.5rem;
  text-align: left; }
  @media (min-width: 48rem) {
    .styles_sectionTitle__pneHu {
      font-size: 2.5rem; } }

.styles_decorativeDivider__JsQa7 {
  width: 6rem;
  height: 0.125rem;
  background: linear-gradient(90deg, #6366f1, #dc2626, #8b5cf6);
  border-radius: 0.0625rem; }

.styles_doodlesCanvas__Tc1Re {
  position: relative;
  margin: 0 auto;
  overflow: visible;
  height: 90vh; }

.styles_doodle__xMWAx {
  position: absolute;
  min-width: 7rem;
  max-width: 18rem;
  padding: 3rem 1.5rem;
  background: rgba(255, 255, 255, 0.86);
  border: 0.1875rem solid #8080805c;
  border-radius: 54% 72% 36% 54% / 54% 36% 54% 72%;
  color: #808080e6;
  box-shadow: 0 0.75rem 2rem rgba(0, 0, 0, 0.08);
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  transition: transform 200ms ease, box-shadow 200ms ease, background 200ms ease;
  --tilt: 0deg;
  animation-name: styles_floatMove__VRBLv;
  animation-iteration-count: infinite;
  animation-timing-function: ease-in-out;
  will-change: transform;
  backdrop-filter: blur(2px);
  isolation: isolate; }
  .styles_doodle__xMWAx:focus-visible {
    outline: 0.125rem dashed #a0aec0;
    outline-offset: 0.25rem; }
  .styles_doodle__xMWAx .styles_doodleTitle__LzFgo {
    margin: 0;
    font-size: 1.125rem;
    font-weight: 600;
    color: #808080e6;
    text-align: center;
    transition: font-size 200ms ease; }
  .styles_doodle__xMWAx.styles_expanded__8yjZE .styles_doodleTitle__LzFgo {
    font-size: 0.9rem; }
  .styles_doodle__xMWAx .styles_doodleDescription__86r6P {
    font-size: 1.25rem;
    color: #808080b8;
    line-height: 1.6;
    margin-top: 0.5rem;
    max-height: 0;
    opacity: 0;
    overflow: scroll;
    transition: max-height 220ms ease, opacity 180ms ease;
    max-width: 75%;
    text-align: center;
    -ms-overflow-style: none;
    scrollbar-width: none; }
    .styles_doodle__xMWAx .styles_doodleDescription__86r6P::-webkit-scrollbar {
      display: none; }

.styles_expanded__8yjZE {
  z-index: 20;
  background: rgba(255, 255, 255, 0.98);
  box-shadow: 0 1rem 2.5rem rgba(0, 0, 0, 0.16);
  padding: 3rem; }
  .styles_expanded__8yjZE .styles_doodleDescription__86r6P {
    opacity: 1;
    max-height: 20rem;
    max-width: 90%; }

.styles_doodle__xMWAx:nth-child(1) {
  border-style: dashed;
  border-radius: 65% 35% 40% 60% / 55% 45% 60% 40%;
  --tilt: 8deg; }

.styles_doodle__xMWAx:nth-child(2) {
  border-style: double;
  border-radius: 28% 72% 58% 42% / 42% 58% 38% 62%;
  --tilt: -12deg; }

.styles_doodle__xMWAx:nth-child(3) {
  border-style: dotted;
  border-radius: 72% 28% 48% 52% / 48% 52% 58% 42%;
  --tilt: 10deg; }

.styles_doodle__xMWAx:nth-child(4) {
  border-style: ridge;
  border-radius: 54% 46% 40% 60% / 62% 38% 58% 42%;
  --tilt: 16deg; }

.styles_doodle__xMWAx:nth-child(5) {
  border-style: groove;
  border-radius: 40% 60% 52% 48% / 60% 40% 50% 50%;
  --tilt: -6deg; }

.styles_doodle__xMWAx:nth-child(6) {
  border-style: dashed;
  border-radius: 58% 42% 60% 40% / 44% 56% 42% 58%;
  --tilt: 6deg; }

.styles_doodle__xMWAx:nth-child(7) {
  border-style: dotted;
  border-radius: 50% 50% 60% 40% / 40% 60% 50% 50%;
  --tilt: -10deg; }

@keyframes styles_floatMove__VRBLv {
  0%,
  100% {
    transform: translate(0, 0) rotate(var(--tilt)); }
  25% {
    transform: translate(-1rem, -1rem) rotate(calc(var(--tilt) + 2deg)); }
  50% {
    transform: translate(1rem, -0.5rem) rotate(calc(var(--tilt) + 4deg)); }
  75% {
    transform: translate(0.5rem, 1rem) rotate(calc(var(--tilt) + 1deg)); } }

@media (max-width: 48rem) {
  .styles_doodlesCanvas__Tc1Re {
    height: auto;
    min-height: 36rem; }
  .styles_doodle__xMWAx {
    position: static;
    margin: 1rem auto;
    width: clamp(14rem, 86vw, 24rem);
    animation: styles_floatMove__VRBLv 8s ease-in-out infinite; } }
`, "",{"version":3,"sources":["webpack://./src/modules/shelter/components/screens/LandingPage/components/EssentialsSection/styles.module.scss","webpack://./src/modules/Core/styles/variables.scss"],"names":[],"mappings":"AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EAEvB,oBAAoB;EACpB,qBCDc;EDEd,+BCCgB;EDAhB,iBAAiB;EACjB,kBAAkB,EAAA;;AAGpB;EACE,WAAW;EACX,iBAAiB,EAAA;;AAGnB;EACE,6BAA6B;EAC7B,cAAc;EACd,eAAe,EAAA;;AAGjB;EACE,kBAAkB,EAAA;;AAIpB;EACE,mBAAmB;EACnB,gBAAgB;EAChB,gBCjBgB;EDkBhB,qBAAqB;EACrB,gBAAgB,EAAA;EAEhB;IAPF;MAQI,iBAAiB,EAAA,EAEpB;;AAED;EACE,WAAW;EACX,gBAAgB;EAChB,6DAA6D;EAC7D,wBAAwB,EAAA;;AAI1B;EACE,kBAAkB;EAGlB,cAAc;EACd,iBAAiB;EACjB,YAAY,EAAA;;AAGd;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,qCAAqC;EACrC,iCCrDgB;EDsDhB,gDAAgD;EAChD,gBCnDgB;EDoDhB,8CAA8C;EAC9C,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,8EAA8E;EAC9E,YAAO;EACP,uCAAyB;EACzB,mCAAmC;EACnC,sCAAsC;EACtC,sBAAsB;EACtB,0BAA0B;EAC1B,kBAAkB,EAAA;EAnBpB;IAsBI,gCAAgC;IAChC,uBAAuB,EAAA;EAvB3B;IA2BI,SAAS;IACT,mBAAmB;IACnB,gBAAgB;IAChB,gBCzEc;ID0Ed,kBAAkB;IAClB,gCAAgC,EAAA;EAhCpC;IAoCI,iBAAiB,EAAA;EApCrB;IAwCI,kBAAkB;IAClB,gBCrFc;IDsFd,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,UAAU;IACV,gBAAgB;IAChB,qDAAqD;IACrD,cAAc;IACd,kBAAkB;IAOlB,wBAAwB;IACxB,qBAAqB,EAAA;IAzDzB;MAqDM,aAAa,EAAA;;AASnB;EACE,WAAW;EACX,qCAAqC;EACrC,6CAA6C;EAC7C,aAAa,EAAA;EAJf;IAOI,UAAU;IACV,iBAAiB;IACjB,cAAc,EAAA;;AAKlB;EACE,oBAAoB;EACpB,gDAAgD;EAChD,YAAO,EAAA;;AAGT;EACE,oBAAoB;EACpB,gDAAgD;EAChD,cAAO,EAAA;;AAGT;EACE,oBAAoB;EACpB,gDAAgD;EAChD,aAAO,EAAA;;AAGT;EACE,mBAAmB;EACnB,gDAAgD;EAChD,aAAO,EAAA;;AAGT;EACE,oBAAoB;EACpB,gDAAgD;EAChD,aAAO,EAAA;;AAGT;EACE,oBAAoB;EACpB,gDAAgD;EAChD,YAAO,EAAA;;AAGT;EACE,oBAAoB;EACpB,gDAAgD;EAChD,cAAO,EAAA;;AAGT;EAEE;;IAEE,8CAA8C,EAAA;EAMhD;IACE,mEAAmE,EAAA;EAGrE;IACE,oEAAoE,EAAA;EAGtE;IACE,mEAAmE,EAAA,EAAA;;AAKvE;EACE;IACE,YAAY;IACZ,iBAAiB,EAAA;EAGnB;IACE,gBAAgB;IAChB,iBAAiB;IACjB,gCAAgC;IAChC,0DAA4C,EAAA,EAC7C","sourcesContent":["@import \"src/modules/Core/styles/variables.scss\";\n\n.section {\n  min-height: 100vh;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  // padding: 8rem 1.5rem;\n  padding: 4rem 1.5rem;\n  background: $grey3;\n  border-top: 1px solid $grey10;\n  max-height: 100vh;\n  position: relative;\n}\n\n.essentialsSection {\n  width: 100%;\n  max-height: 100vh;\n}\n\n.contentWrapper {\n  width: -webkit-fill-available;\n  margin: 0 auto;\n  max-width: 80vw;\n}\n\n.headerSection {\n  text-align: center;\n  // margin-bottom: 2rem;\n}\n\n.sectionTitle {\n  font-size: 1.875rem;\n  font-weight: 300;\n  color: $grey90;\n  margin-bottom: 1.5rem;\n  text-align: left;\n\n  @media (min-width: 48rem) {\n    font-size: 2.5rem;\n  }\n}\n\n.decorativeDivider {\n  width: 6rem;\n  height: 0.125rem;\n  background: linear-gradient(90deg, #6366f1, #dc2626, #8b5cf6);\n  border-radius: 0.0625rem;\n}\n\n// Floating doodles canvas, mirroring ReleaseScreen narrative doodles\n.doodlesCanvas {\n  position: relative;\n  // height: vh;\n  // max-width: 80rem;\n  margin: 0 auto;\n  overflow: visible;\n  height: 90vh;\n}\n\n.doodle {\n  position: absolute;\n  min-width: 7rem;\n  max-width: 18rem;\n  padding: 3rem 1.5rem;\n  background: rgba(255, 255, 255, 0.86);\n  border: 0.1875rem solid $grey36;\n  border-radius: 54% 72% 36% 54% / 54% 36% 54% 72%;\n  color: $grey90;\n  box-shadow: 0 0.75rem 2rem rgba(0, 0, 0, 0.08);\n  cursor: pointer;\n  user-select: none;\n  transition: transform 200ms ease, box-shadow 200ms ease, background 200ms ease;\n  --tilt: 0deg;\n  animation-name: floatMove;\n  animation-iteration-count: infinite;\n  animation-timing-function: ease-in-out;\n  will-change: transform;\n  backdrop-filter: blur(2px);\n  isolation: isolate;\n\n  &:focus-visible {\n    outline: 0.125rem dashed #a0aec0;\n    outline-offset: 0.25rem;\n  }\n\n  .doodleTitle {\n    margin: 0;\n    font-size: 1.125rem;\n    font-weight: 600;\n    color: $grey90;\n    text-align: center;\n    transition: font-size 200ms ease;\n  }\n\n  &.expanded .doodleTitle {\n    font-size: 0.9rem;\n  }\n\n  .doodleDescription {\n    font-size: 1.25rem;\n    color: $grey72;\n    line-height: 1.6;\n    margin-top: 0.5rem;\n    max-height: 0;\n    opacity: 0;\n    overflow: scroll;\n    transition: max-height 220ms ease, opacity 180ms ease;\n    max-width: 75%;\n    text-align: center;\n\n    // ensure the scroll is hidden \n    &::-webkit-scrollbar {\n      display: none;\n    }\n\n    -ms-overflow-style: none;\n    scrollbar-width: none;\n\n  }\n}\n\n.expanded {\n  z-index: 20;\n  background: rgba(255, 255, 255, 0.98);\n  box-shadow: 0 1rem 2.5rem rgba(0, 0, 0, 0.16);\n  padding: 3rem;\n\n  .doodleDescription {\n    opacity: 1;\n    max-height: 20rem;\n    max-width: 90%;\n  }\n}\n\n// Variation per index for visual diversity\n.doodle:nth-child(1) {\n  border-style: dashed;\n  border-radius: 65% 35% 40% 60% / 55% 45% 60% 40%;\n  --tilt: 8deg;\n}\n\n.doodle:nth-child(2) {\n  border-style: double;\n  border-radius: 28% 72% 58% 42% / 42% 58% 38% 62%;\n  --tilt: -12deg;\n}\n\n.doodle:nth-child(3) {\n  border-style: dotted;\n  border-radius: 72% 28% 48% 52% / 48% 52% 58% 42%;\n  --tilt: 10deg;\n}\n\n.doodle:nth-child(4) {\n  border-style: ridge;\n  border-radius: 54% 46% 40% 60% / 62% 38% 58% 42%;\n  --tilt: 16deg;\n}\n\n.doodle:nth-child(5) {\n  border-style: groove;\n  border-radius: 40% 60% 52% 48% / 60% 40% 50% 50%;\n  --tilt: -6deg;\n}\n\n.doodle:nth-child(6) {\n  border-style: dashed;\n  border-radius: 58% 42% 60% 40% / 44% 56% 42% 58%;\n  --tilt: 6deg;\n}\n\n.doodle:nth-child(7) {\n  border-style: dotted;\n  border-radius: 50% 50% 60% 40% / 40% 60% 50% 50%;\n  --tilt: -10deg;\n}\n\n@keyframes floatMove {\n\n  0%,\n  100% {\n    transform: translate(0, 0) rotate(var(--tilt));\n  }\n\n  // 25% { transform: translate(-2rem, -2rem) rotate(calc(var(--tilt) + 2deg)); }\n  // 50% { transform: translate(2rem, -1rem) rotate(calc(var(--tilt) + 4deg)); }\n  // 75% { transform: translate(1rem, 2rem) rotate(calc(var(--tilt) + 1deg)); }\n  25% {\n    transform: translate(-1rem, -1rem) rotate(calc(var(--tilt) + 2deg));\n  }\n\n  50% {\n    transform: translate(1rem, -0.5rem) rotate(calc(var(--tilt) + 4deg));\n  }\n\n  75% {\n    transform: translate(0.5rem, 1rem) rotate(calc(var(--tilt) + 1deg));\n  }\n\n}\n\n@media (max-width: 48rem) {\n  .doodlesCanvas {\n    height: auto;\n    min-height: 36rem;\n  }\n\n  .doodle {\n    position: static;\n    margin: 1rem auto;\n    width: clamp(14rem, 86vw, 24rem);\n    animation: floatMove 8s ease-in-out infinite;\n  }\n}","// @import \"src/modules/Core/styles/variables.scss\";\n\n$white90: #ffffffe6;\n$green50: #00800080;\n\n$white10: #ffffff1a;\n$white18: #ffffff2e;\n$white50: #ffffff80;\n\n$grey3:#80808008;\n$grey5: #8080800d;\n$grey7: #80808012;\n$grey10: #8080801a;\n$grey18: #8080802e;\n$grey36: #8080805c;\n$grey50: #80808080;\n$grey54: #8080808a;\n$grey72: #808080b8;\n$grey90: #808080e6;\n$grey: #808080;\n\n\n$purple100: #800080;\n$purple90: #800080e6;\n$purple72:#800080b8;\n$purple50: #80008080;\n$purple36: #8000805c;\n$purple18: #8000802e;\n\n$dark_purple: #480048;\n$deep_purple: #840000;\n\n$baby_blue: #87ceeb;\n$ui_blue: #1976d2;\n$ui_blue90: #1976d2e6;\n$ui_blue72: #1976d2b8;\n$ui_blue50: #1976d280;\n$pond_green: #72bbbb;\n$pond_green72: #72bbbbb8;\n$ocean_blue: #72abab;\n$ocean_blue90: #72ababe6;\n$ocean_blue72: #72ababb8;\n$ocean_blue50: #72abab80;\n$ocean_blue36: #72abab5c;\n$ocean_blue10: #73abab1a;\n$kermit_green: #72ab72;\n$kermit_green72: #72ab72b8;\n$somewhat_certain:#183672;\n$just_say_ok: #721446;\n$success_street: #723618;\n\n$golden: #ffd700;\n$_golden: #D4AF37;\n$bronze: #cd7f32;\n\n$bronze80: #cd7f32c2;\n$bronze50: #cd7f3280;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"section": `styles_section__wxobX`,
	"essentialsSection": `styles_essentialsSection__ZImve`,
	"contentWrapper": `styles_contentWrapper__bQIHD`,
	"headerSection": `styles_headerSection__dbeGN`,
	"sectionTitle": `styles_sectionTitle__pneHu`,
	"decorativeDivider": `styles_decorativeDivider__JsQa7`,
	"doodlesCanvas": `styles_doodlesCanvas__Tc1Re`,
	"doodle": `styles_doodle__xMWAx`,
	"floatMove": `styles_floatMove__VRBLv`,
	"doodleTitle": `styles_doodleTitle__LzFgo`,
	"expanded": `styles_expanded__8yjZE`,
	"doodleDescription": `styles_doodleDescription__86r6P`
};
export default ___CSS_LOADER_EXPORT___;
